import { type ReactNode } from "react"

/** Section eyebrow: a soft pill chip, sentence case — one shared treatment
 *  so every section opens the same way. */
export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="bg-lp-surface text-lp-fg inline-flex items-center rounded-full px-4 py-1.5 text-sm font-medium">
      {children}
    </span>
  )
}
